/**
 * PUNTO DE ENTRADA
 * =============================================================================
 * Monta la página y envuelve todo en el proveedor de idioma, que es lo que hace
 * que el selector ES | EN cambie de verdad todos los textos.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ProveedorIdioma } from './i18n/useIdioma';
import { ProveedorAjustes } from './i18n/useAjustes';
import { Pagina } from './Pagina';
import './estilos.css';

const raiz = document.getElementById('raiz');

if (!raiz) {
  // Si esto pasa, el index.html y este archivo no coinciden. Mejor decirlo que
  // dejar la pantalla en blanco.
  document.body.innerHTML =
    '<p style="font-family:sans-serif;padding:24px;color:#fff;background:#05080f">' +
    'No se encontró el contenedor de la página. Recarga la página.</p>';
} else {
  createRoot(raiz).render(
    <StrictMode>
      <ProveedorIdioma>
        {/* Los ajustes van dentro del idioma porque el pais y los avisos
            dependen de cual este elegido. */}
        <ProveedorAjustes>
          <Pagina />
        </ProveedorAjustes>
      </ProveedorIdioma>
    </StrictMode>
  );
}
